import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import("@/pages/homepage"),
    },
    {
      path: '/word',
      name: 'word',
      component: () => import("@/pages/wordpage"),
    },
    {
      path: '/sent',
      name: 'sent',
      component: () => import("@/pages/sentence"),
    },
    {
      path: '/book',
      name: 'book',
      component: () => import("@/pages/book"),
    },
    {
      path: '/book/analyse',
      name: 'book-analyse',
      component: () => import("@/pages/book/analysis"),
    },
    {
      path: '/reader',
      name: 'reader',
      component: () => import("@/pages/reader"),
    },
    {
      path: '/chartdemo',
      name: 'chartdemo',
      component: () => import("@/pages/chartdemo"),
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js